import React from 'react';
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import SimpleReactValidator from "simple-react-validator";
import { getUserRole } from "../../utils/index";
import apiUrl from "../../apiUrlConstant";
import axios from "axios";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert } from 'react-bootstrap';

class TaskAdd extends React.Component {

    constructor(props) {
        super(props);

        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
        });

        this.state = {
            stages: ['active','inactive'],
            status: ['active','inactive'],
            role: getUserRole(),
            initialValues: {

            },
            errorMessages: [],
            showAlert : false,
        };
    }
    componentDidMount() {
    }

    render() {
        return (
            <div>
                {/* <h3>Add Task</h3>
                <p>{this.props.leadId}</p> */}
                <Formik
                    enableReinitialize={true}
                    initialValues={this.state.initialValues}
                    onSubmit={(values, actions) => {

                        if (!this.validator.allValid()) {
                            this.validator.getErrorMessages();
                            this.validator.showMessages();
                            //this.forceUpdate();
                            return false;
                        }

                        var self = this;
                        axios({
                            method: "post",
                            url: apiUrl.apiUrl.url + "/leads/create-sub-stage",
                            data: values,
                        }).then(function (response) {
                            
                            if (response.data.status == 'success') {
                                setTimeout(() => {
                                    self.props.closeModal(); // Close modal after form submission
                                }, 1000);
                            } else {
                                actions.setSubmitting(false);
                                actions.setErrors(response.data);

                                const errorMessages = Object.values(response.data.errors).flat().map((msg, index) => <li key={`error_${index}`}>{msg}</li>);
                
                                self.setState({
                                    showAlert: true,
                                    errorMessages: errorMessages
                                });
                            }
                        });
                    }
                    }
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <>
                            {this.state.showAlert == true ? (
                                <Alert variant="danger">
                                    <ul className="m-0">
                                       {this.state.errorMessages}
                                    </ul>
                                    <span onClick={() => this.setState({ showAlert: false })}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M10.586 12L2.793 4.207l1.414-1.414L12 10.586l7.793-7.793l1.414 1.414L13.414 12l7.793 7.793l-1.414 1.414L12 13.414l-7.793 7.793l-1.414-1.414z" />
                                        </svg>
                                    </span>
                                </Alert>
                            ) : null}
                            <div className="unitFormContainerNew">
                                <Form autoComplete="off" onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission on Enter key press
                                        }
                                    }} onSubmit={handleSubmit}>
                                    <div className="newGridSectionParent">
                                        <div className="newGridSectionForFormMain newGridSectionForFormMainOneFr">

                                            <div className="newGridSectionInner">
                                                <label>Stage</label>
                                                <div className="position-relative">
                                                    <Field as="select" name="stage" onChange={handleChange}>
                                                        <option value="">Select Stage</option>
                                                        {this.state.stages.map(stage => (
                                                            <option key={stage} value={stage}>{stage.charAt(0).toUpperCase() + stage.slice(1)}</option>
                                                        ))}
                                                    </Field>
                                                    {this.validator.message("Stage", values.stage, "required", { className: "text-danger" })}
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Title <span className="astrik">*</span></label>
                                                <div className="position-relative">
                                                    <Field type="text" name="title" onChange={handleChange} />
                                                    {this.validator.message("Title", values.title, "required", { className: "text-danger" })}
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Winning Probability Percentage</label>
                                                <div className="position-relative">
                                                    <Field type="text"  name="percentage" onChange={handleChange} />
                                                    {this.validator.message("percentage", values.percentage, "numeric|min:1,num|numeric|max:100,num", { className: "text-danger" })}
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Sequence No <span className="astrik">*</span></label>
                                                <div className="position-relative">
                                                    <Field type="text" name="sequence" onChange={handleChange} />
                                                    {this.validator.message("Sequence", values.sequence, "required|numeric", { className: "text-danger" })}
                                                </div>
                                            </div>

                                        </div>
                                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                            <button type="button" className='cancel_button' onClick={this.props.closeModal}>
                                                Cancel
                                            </button>
                                            <button type="submit" className='add_button' disabled={isSubmitting}>
                                                {isSubmitting && <FontAwesomeIcon icon={faSpinner} className="spinner-icon" />} Submit
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            </div>

                        </>
                    )}

                </Formik>
            </div>
        );
    }
};

export default TaskAdd;